import { IIconStyles, IStackStyles, ITheme, memoizeFunction } from '@fluentui/react';
import { pcpRedPalette } from './themes/palette';

const notificationIconSmallPaddingREM = '0.125rem'; //2px
const notificationIconSmallSizeREM = '0.875rem';  //14px

export const notificationIconSmallContainerStyles = memoizeFunction(
    (theme: ITheme, horizontalAlign: 'left' | 'right'): IIconStyles => ({
        root: Object.assign(
            {
                borderRadius: notificationIconSmallSizeREM, // Create a css circle. This should match the height.
                height: notificationIconSmallSizeREM,
                minWidth: notificationIconSmallSizeREM, // use min-width over width as we want to extend the width of the notification icon when contents is more than one character (e.g. 9+)
                background: pcpRedPalette.notificationForeground,
                padding: notificationIconSmallPaddingREM,

                // positioning to place the badge within the button appropriately. Button DOM-element should have css 'position' other than 'static'.
                position: 'absolute',
                top: 0,
            },
            horizontalAlign == 'right' ?
                { right: 0 } :
                { left: 0 }
            ) as IIconStyles
    })
);

export const notificationTextSmallStyles = memoizeFunction(
    (theme: ITheme): IStackStyles => ({
        root: {
            color: 'white',
            fontSize: '10px',    //smaller then default value of theme.fonts.tiny.fontSize
            lineHeight: '1em'
        }
    })
);